<app-header-banner/>
<div class="globalContent">
  <router-outlet/>
</div>
<app-footer/> <!-- use padding-bottom: 60px; before using this component -->
